export enum StatusType {
  Gray = 'gray',
  Red = 'red',
  Brown = 'brown',
  Orange = 'orange',
  Beige = 'beige',
  Green = 'green',
  Purple = 'purple',
  Blue = 'blue',
  White = 'white',
  Yellow = 'yellow',
}
